import { Controller } from "@hotwired/stimulus"
// We are using CDNs in the document head as we are having issues with the import and utils file

// Connects to data-controller="phone-input"
export default class extends Controller {
  static targets = ["input", "hidden"]
  
  initialize() {
    this.phoneInput = intlTelInput(this.inputTarget, {
      initialCountry: "fr",
      preferredCountries: ["fr", "gb", "be", "nl", "de", "es", "us"],
      customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
        return "ex. " + selectedCountryPlaceholder;
      }
    })
  }

  update() {
    this.hiddenTarget.value = this.phoneInput.getNumber()
  }

}
